// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import VueBus from 'vue-bus'
Vue.use(VueBus)

import axios from 'axios'
Vue.prototype.$axios = axios

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

import 'animate.css'
import '../node_modules/basscss-basic/index.css'
import '../node_modules/basscss/css/basscss.css'
import './main.css'

import 'babel-polyfill'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js